import React from 'react';
import { Search, MessageSquareText, Handshake, Building2, Users2, Briefcase } from 'lucide-react';
import { Reveal, Stagger, Item } from './Reveal';

const pillars = [
  { icon: Search, title: 'Wir suchen', text: 'Aktiv in unserem Netzwerk aus 4.200+ Fach- und Führungskräften – nicht nur auf Jobportalen.' },
  { icon: MessageSquareText, title: 'Wir interviewen & briefen', text: 'Jeder Kandidat wird von uns geprüft und auf deine Position vorbereitet, bevor du ihn siehst.' },
  { icon: Handshake, title: 'Du stellst ein', text: 'Du führst nur noch Gespräche mit Menschen, die fachlich und menschlich passen.' },
];

const audiences = [
  { icon: Building2, label: 'Start-up bis Konzern' },
  { icon: Users2, label: 'HR-Leiter & Geschäftsführer' },
  { icon: Briefcase, label: 'Fach- & Führungskräfte' },
];

const IntroSection = () => (
  <section id="intro" className="relative bg-white py-24 lg:py-32 overflow-hidden" data-testid="intro-section">
    <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-violet-100/60 blur-[120px] pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-14 lg:gap-20 items-start">
      <div className="lg:col-span-6">
        <Reveal>
          <span className="eyebrow text-violet-700"><span className="eyebrow-line" />Was ist HIREKA</span>
          <h2 className="mt-6 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.08] text-slate-900">
            Die Recruiting-Agentur, die dir{' '}
            <span className="relative inline-block">
              <span className="relative z-10">Kandidaten liefert</span>
              <span className="absolute left-0 right-0 bottom-1 h-3 bg-amber-300/60 -rotate-1 z-0" />
            </span>{' '}
            – nicht nur Lebensläufe.
          </h2>
          <p className="mt-7 text-base md:text-lg text-slate-600 leading-relaxed">
            Klassische Personalvermittler schicken dir Stapel von CVs, lassen dich Wochen warten und kassieren am Ende 20–35 % vom Jahresgehalt.
            HIREKA macht es anders: Ein Festpreis, ein persönlicher Recruiter, ein gebriefter Kandidat in 24 Stunden – und wenn er nicht passt, besetzen wir kostenlos nach.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-10 flex flex-wrap gap-3" data-testid="intro-audiences">
          {audiences.map((a, i) => (
            <span key={i} className="inline-flex items-center gap-2 rounded-full border border-stone-200 bg-cream px-4 py-2 text-sm font-medium text-slate-700">
              <a.icon className="w-4 h-4 text-violet-600" /> {a.label}
            </span>
          ))}
        </Reveal>
      </div>

      <Stagger className="lg:col-span-6 space-y-4" stagger={0.12}>
        {pillars.map((p, i) => (
          <Item key={i} className="lux-card p-6 lg:p-7 flex gap-5 items-start" data-testid={`intro-pillar-${i}`}>
            <div className="shrink-0 w-12 h-12 rounded-2xl bg-obsidian flex items-center justify-center shadow-lg shadow-violet-900/20">
              <p.icon className="w-5 h-5 text-amber-400" />
            </div>
            <div>
              <div className="flex items-center gap-3">
                <span className="font-display text-xs font-bold text-amber-500 tracking-[0.2em]">0{i + 1}</span>
                <h3 className="text-lg md:text-xl font-bold text-slate-900">{p.title}</h3>
              </div>
              <p className="mt-2 text-slate-600 leading-relaxed text-sm md:text-base">{p.text}</p>
            </div>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);

export default IntroSection;
